<template>
  <div>
    <!-- Table Filter + Header -->
    <Select caption="FILTER" icon="cil-filter" @filter-changed="handleFilter" />

    <CCard class="bg-style2 mt-3">
      <CCardHeader
          class="bg-gradient-dark text-white"
          style="border-top-left-radius:1rem; border-top-right-radius:1rem;"
      >
        <span class="font-weight-bold h6">
          <CIcon v-if="icon" :name="icon" /> {{ caption }}
        </span>
        <div class="card-header-actions">Total: {{ filteredUsers.length }}</div>
      </CCardHeader>

      <CCardBody>
        <CDataTable
            :table-filter="{label:''}"
            :items="filteredUsers"
            :fields="fields"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :dark="dark"
            :loading="loading"
            :items-per-page="10"
            pagination
        >
          <template #index="{ index }">
            <td class="text-center">{{ index + 1 }}</td>
          </template>

          <template #status="{ item }">
            <td>
              <CBadge :color="getStatusColor(item.status)">
                {{ item.status }}
              </CBadge>
            </td>
          </template>

          <template #action="{ item }">
            <td class="text-center">
              <CButton
                  size="sm"
                  color="primary"
                  shape="pill"
                  variant="outline"
                  @click="showDetail(item)"
              >
                <CIcon name="cil-description" /> Details
              </CButton>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>

    <!-- Detail / Approval Modal -->
    <CModal
        :show.sync="detailModalVisible"
        :title="'Candidate Registration Detail'"
        dialogClass="modal-dialog"
        style="width: 98%; max-width: 1400px; margin: 2rem auto;"
    >
      <!-- Header -->
      <template #header>
        <div class="d-flex justify-content-between w-100">
          <h5 class="modal-title fw-bold">Candidate Registration Detail</h5>
          <CButton color="link" class="text-danger p-0 m-0" @click="detailModalVisible = false">
            <CIcon name="cil-x" size="lg" />
          </CButton>
        </div>
      </template>

      <!-- Body -->
      <template #default>
        <div v-if="selected" class="p-3">
          <CForm>
            <!-- Images -->
            <CRow class="mb-4">
              <CCol md="6" class="text-center">
                <a v-if="selected.raw.picture" :href="fullUrl(selected.raw.picture)" target="_blank">
                  <img
                      :src="fullUrl(selected.raw.picture)"
                      alt="Profile Photo"
                      class="img-thumbnail"
                      style="max-height: 200px; max-width: 100%; cursor: zoom-in; border-radius: 0.5rem;"
                  />
                </a>
                <div class="mt-2">Profile Photo</div>
              </CCol>
              <CCol md="6" class="text-center">
                <a v-if="selected.raw.transcript" :href="fullUrl(selected.raw.transcript)" target="_blank">
                  <img
                      :src="fullUrl(selected.raw.transcript)"
                      alt="Transcript"
                      class="img-thumbnail"
                      style="max-height: 200px; max-width: 100%; cursor: zoom-in; border-radius: 0.5rem;"
                  />
                </a>
                <div class="mt-2">Transcript</div>
              </CCol>
            </CRow>

            <!-- Text Fields -->
            <CRow>
              <CCol md="6" class="mb-3">
                <CFormLabel>Name</CFormLabel>
                <input type="text" :value="selected.name" class="form-control" disabled />
              </CCol>
              <CCol md="6" class="mb-3">
                <CFormLabel>Student ID</CFormLabel>
                <input type="text" :value="selected.studentId" class="form-control" disabled />
              </CCol>
              <CCol md="6" class="mb-3">
                <CFormLabel>School</CFormLabel>
                <input type="text" :value="selected.department" class="form-control" disabled />
              </CCol>
              <CCol md="6" class="mb-3">
                <CFormLabel>Major</CFormLabel>
                <input type="text" :value="selected.major" class="form-control" disabled />
              </CCol>
              <CCol md="6" class="mb-3">
                <CFormLabel>Line ID</CFormLabel>
                <input type="text" :value="selected.line" class="form-control" disabled />
              </CCol>
              <CCol md="6" class="mb-3">
                <CFormLabel>GPAX</CFormLabel>
                <input type="text" :value="selected.gpax" class="form-control" disabled />
              </CCol>
            </CRow>

            <!-- Policy -->
            <div class="mb-3">
              <CFormLabel>Policy</CFormLabel>
              <div
                  class="p-3 border rounded policy-preview"
                  style="min-height:100px; background:#f9f9f9; max-width: 100%; overflow-x: auto;"
              >
                <div class="policy-content" v-html="selected.policy" />
              </div>
            </div>
          </CForm>
        </div>
      </template>

      <!-- Footer -->
      <template #footer>
        <div v-if="selected && selected.raw && selected.raw.status">
          <template v-if="selected.raw.status.status_name === 'Pending'">
            <CButton class="mr-2" color="success" @click="changeStatus('approve')">Approve</CButton>
            <CButton color="danger" @click="changeStatus('decline')">Decline</CButton>
          </template>
          <template v-else>
        <span class="fw-bold text-muted">
          Status: {{ selected.raw.status.status_name }}
        </span>
          </template>
        </div>
      </template>
    </CModal>


  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import Select from '@/projects/views/committee/components/select.vue'
import api from '@/service/api.js'
import Swal from 'sweetalert2'
import {
  CCard, CCardHeader, CCardBody,
  CRow, CCol, CForm, CFormLabel,
  CInput, CTextarea, CButton, CBadge,
  CDataTable, CModal
} from '@coreui/vue'
import CIcon from '@coreui/icons-vue'

export default {
  name: 'AdminCandidateList',
  components: {
    Select,
    CCard, CCardHeader, CCardBody,
    CRow, CCol, CForm, CFormLabel,
    CInput, CTextarea, CButton, CBadge,
    CDataTable, CModal,
    CIcon
  },
  props: {
    icon: { type: String, default: 'cil-settings' },
    caption: { type: String, default: 'List of Candidates' },
    hover: Boolean, striped: Boolean, bordered: Boolean,
    small: Boolean, fixed: Boolean, dark: Boolean,
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      users: [],
      filters: { status: null, userType: null },
      detailModalVisible: false,
      selected: null,
      isChangingStatus: false,
      imageBaseURL: 'https://election-su.mfu.ac.th'
    }
  },
  computed: {
    ...mapGetters({ currentUser: 'auth/user' }),
    fields() {
      return [
        { key: 'index', label: 'No.', _style: 'text-align:center' },
        { key: 'name', label: 'Name' },
        { key: 'studentId', label: 'Student ID' },
        { key: 'candidateType', label: 'Candidate Type' },
        { key: 'status', label: 'Status' },
        { key: 'action', label: 'Actions', _style: 'text-align:center' }
      ]
    },
    filteredUsers() {
      return this.users.filter(u => {
        const matchStatus = !this.filters.status || u.status === this.filters.status.value
        const matchType = !this.filters.userType || u.candidateType === this.filters.userType.value
        return matchStatus && matchType
      })
    }
  },
  methods: {
    async fetchCandidates() {
      const res = await api.candidate('getCandidates')
      const candidates = res?.data?.data || []
      this.users = candidates
          .filter(c => c.accountID)
          .map(c => ({
            raw: c,
            _id: c._id,
            accountID: c.accountID?._id || c.accountID,
            name: c.accountID.name || '-',
            email: c.accountID.email || '-',
            studentId: c.accountID.studentId || '-',
            department: c.accountID.department?.department_name || '-',
            major: c.accountID.major?.major_name || '-',
            line: c.line || '',
            gpax: c.gpax || '',
            picture: c.picture || '',
            transcript: c.transcript || '',
            policy: c.policy || '',
            candidateType: c.type?.type_name || '-',
            status: c.status?.status_name || 'Unknown'
          }))
    },
    getStatusColor(s) {
      return s === 'Pending' ? 'warning'
          : s === 'Approved' ? 'success'
              : s === 'Declined' ? 'danger'
                  : 'secondary'
    },
    handleFilter(f) {
      this.filters = f
    },
    showDetail(item) {
      this.selected = item
      this.detailModalVisible = true

      this.$nextTick(() => {
        const modalDialog = document.querySelector('.modal-dialog')
        if (modalDialog) {
          modalDialog.style.maxWidth = '1200px'
          modalDialog.style.width = '95%'
          modalDialog.style.margin = '2rem auto'
        }
      })
    },
    fullUrl(path) {
      return path ? `${this.imageBaseURL}${path}` : ''
    },
    async changeStatus(action) {
      const statusId = action === 'approve'
          ? '685d14872435685988f5f22c' // Approved
          : '685d14932435685988f5f22f' // Declined

      const candidateID = this.selected?._id
      const accountID = this.selected?.accountID || this.selected?.raw?.accountID?._id

      console.log('[StatusChange] Sending payload:', { candidateID, accountID, status: statusId })

      if (!candidateID || !accountID) {
        console.error('[StatusChange] Missing candidateID or accountID')
        return
      }

      const result = await Swal.fire({
        title: `Confirm to ${action}?`,
        text: `This action cannot be undone.`,
        icon: action === 'approve' ? 'success' : 'warning',
        showCancelButton: true,
        confirmButtonText: action === 'approve' ? '✅ Approve' : '❌ Decline',
        cancelButtonText: 'Cancel'
      })

      if (!result.isConfirmed) return

      this.isChangingStatus = true
      try {
        const response = await api.candidate('changeCandidateStatus', {
          candidateID,
          accountID,
          status: statusId
        })
        console.log('[API CALL] Sending to backend:', {
          candidateID,
          accountID,
          status: statusId
        })

        await Swal.fire({
          icon: 'success',
          title: `Candidate ${action}d successfully!`,
          timer: 2000,
          showConfirmButton: false
        })

        this.detailModalVisible = false
        await this.fetchCandidates()
      } catch (e) {
        console.error('[StatusChange] Error:', e)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: e.response?.data?.message || 'Failed to update candidate status.'
        })
      } finally {
        this.isChangingStatus = false
      }
    }
  },
  created() {
    this.fetchCandidates()
  }
}
</script>
<style scoped>
.detail-modal-card .modal-content {
  padding: 2rem;
  font-size: 1rem;
}

.detail-modal-card .modal-title {
  font-size: 1.5rem;
  font-weight: bold;
}

.detail-modal-card .img-thumbnail {
  max-height: 250px;
  border-radius: 0.75rem;
  border: 2px solid #dee2e6;
}
.detail-modal-card .border.rounded {
  background-color: #f9f9f9;
  padding: 1rem;
  font-size: 0.95rem;
  line-height: 1.5;
  border-radius: 0.5rem;
}
.detail-modal-card input,
.detail-modal-card textarea {
  font-size: 1rem;
  padding: 0.6rem 1rem;
  border-radius: 0.5rem;
}
::v-deep .modal-dialog {
  max-width: 800px !important;
  width: 98% !important;
  margin: 2rem auto !important;
}

::v-deep .modal-content {
  width: 100% !important;
}

.policy-preview .policy-content img {
  width: 100%;
  height: 70%;
  object-fit: contain; /* รักษาสัดส่วนภาพ */
  border-radius: 0.5rem;
  display: block;
  margin: 0.5rem auto;
}
.policy-preview {
  max-height: 400px;
  overflow-y: auto;
}
@media (max-width: 768px) {
  .modal-content {
    width: 95% !important;
  }

  .policy-preview {
    font-size: 0.9rem;
  }
}
.policy-preview .policy-content img {
  width: 100%;
  height: 70%;
  object-fit: contain;
  display: block;
  margin: auto;
}

</style>
